import { node } from 'prop-types'
import { AccountProvider } from './account-context'
import { AdAccountProvider } from './ad-account-context'
import { AdvertiserProvider } from './advertiser-context'
import { ApiKeyProvider } from './api-keys-context'
import { CampaignProvider } from './campaign-context'
import { ConnectorProvider } from './connector-context'
import { DialogProvider } from './dialog-context'
import { DraftProvider } from './draft-context'
import { FieldSetProvider } from './field-set-context'
import { FolderProvider } from './folder-context'
import { GroupProvider } from './group-context'
import { IntegrationProvider } from './integration-context'
import { ListProvider } from './list-context'
import { ModalProvider } from './modal-context'
import { PageHeaderProvider } from './pageHeader'
import { PatternProvider } from './pattern-context'
import { PlacementProvider } from './placement-context'
import { ReportProvider } from './report-context'
import { SubmissionProvider } from './submission-context'
import { TargetProvider } from './target-context'
import { TemplateProvider } from './template-context'
import { UserProvider } from './user-context'

export const RootContext = ({ children }) => {
  return (
    <ListProvider>
      <ModalProvider>
        <DialogProvider>
          <GroupProvider>
            <UserProvider>
              <GroupProvider>
                <PatternProvider>
                  <AccountProvider>
                    <FieldSetProvider>
                      <TargetProvider>
                        <TemplateProvider>
                          <IntegrationProvider>
                            <ConnectorProvider>
                              <ReportProvider>
                                <SubmissionProvider>
                                  <FolderProvider>
                                    <DraftProvider>
                                      <AdvertiserProvider>
                                        <CampaignProvider>
                                          <PlacementProvider>
                                            <AdAccountProvider>
                                              <ApiKeyProvider>
                                                <DraftProvider>
                                                  <PlacementProvider>
                                                    <PageHeaderProvider>
                                                      {children}
                                                    </PageHeaderProvider>
                                                  </PlacementProvider>
                                                </DraftProvider>
                                              </ApiKeyProvider>
                                            </AdAccountProvider>
                                          </PlacementProvider>
                                        </CampaignProvider>
                                      </AdvertiserProvider>
                                    </DraftProvider>
                                  </FolderProvider>
                                </SubmissionProvider>
                              </ReportProvider>
                            </ConnectorProvider>
                          </IntegrationProvider>
                        </TemplateProvider>
                      </TargetProvider>
                    </FieldSetProvider>
                  </AccountProvider>
                </PatternProvider>
              </GroupProvider>
            </UserProvider>
          </GroupProvider>
        </DialogProvider>
      </ModalProvider>
    </ListProvider>
  )
}

RootContext.propTypes = {
  children: node.isRequired,
}
